import React, {useEffect, useState} from 'react';
import {Link, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import UtilisateurCreation from "../../../components/Admin/Utilisateurs/UtilisateurCreation";
import UtilisateursVue from "../../../components/Admin/Utilisateurs/UtilisateursVue";
import UtilisateurVue from "../../../components/Admin/Utilisateurs/UtilisateurVue";
import UtilisateursCreationEnMasse from "../../../components/Admin/Utilisateurs/UtilisateursCreationEnMasse";

function AdminUtilisateursPage() {
    const {user} = useUser();
    const { updateDynamicBreadcrumb } = useBreadcrumb();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const modeOptions = {
        'creation': <UtilisateurCreation utilisateur={null} />,
        'creation_en_masse_csv': <UtilisateursCreationEnMasse utilisateur={null} searchParams={searchParams} />,
        'consultation': <UtilisateursVue />,
        'default': <UtilisateursVue />
    };
    const ComponentToRender = modeOptions[mode] || modeOptions['default'];

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ }));
    }, []);

    return (
        <div className="content_tab">
            <TitleMain text="Utilisateurs"/>
            {ComponentToRender}
        </div>
    )
}

export default AdminUtilisateursPage;
